/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerUpdateMutationRequest, WorkflowApplicationsControllerUpdateMutationResponse, WorkflowApplicationsControllerUpdatePathParams, WorkflowApplicationsControllerUpdate400, WorkflowApplicationsControllerUpdate401, WorkflowApplicationsControllerUpdate403, WorkflowApplicationsControllerUpdate404 } from "../../models/workflowsController/WorkflowApplicationsControllerUpdate";

function getWorkflowApplicationsControllerUpdateUrl(id: WorkflowApplicationsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/workflow-applications/${id}` as const }  
  return res
}

/**
 * @summary Update workflow application metadata
 * {@link /api/v1/workflow-applications/:id}
 */
export async function workflowApplicationsControllerUpdate(id: WorkflowApplicationsControllerUpdatePathParams["id"], data?: WorkflowApplicationsControllerUpdateMutationRequest, config: Partial<RequestConfig<WorkflowApplicationsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowApplicationsControllerUpdateMutationResponse, ResponseErrorConfig<WorkflowApplicationsControllerUpdate400 | WorkflowApplicationsControllerUpdate401 | WorkflowApplicationsControllerUpdate403 | WorkflowApplicationsControllerUpdate404>, WorkflowApplicationsControllerUpdateMutationRequest>({ method : "PATCH", url : getWorkflowApplicationsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}